export default __webpack_public_path__ + "static/media/proj2.1c202dec.png";